import React from 'react'
import st from './Analysis.module.scss'

const FunnelAnalyticsBlock = ({ data, statuses, loading, translate }) => {
  if (loading) return <div className={st.loading}>Загрузка данных...</div>
  if (!data || Object.keys(data).length === 0)
    return <div className={st.empty}>Нет данных за выбранный период</div>

  const newDeals = data.new_deals || 0
  const { new_deals, ...statusData } = data

  return (
    <div className={st.funnelWrapper}>
      <div className={st.funnelTable}>
        {/* ЛЕВЫЙ БЛОК: НОВЫЕ */}
        <div className={st.newDealsBlock}>
          <div className={st.newLabel}>НОВЫЕ</div>
          <div className={st.newDealsCount}>{newDeals}</div>
        </div>

        {/* ПРАВАЯ ЧАСТЬ: СТАТУСЫ */}
        <div className={st.funnelColumnsContainer}>
          {/* 1. СТРОКА ЗАГОЛОВКОВ (СЕЙЧАС) */}
          <div className={st.rowLabelRow}>
            <div className={st.sideLabel}>СЕЙЧАС</div>
            {statuses.map((status) => {
              const info = statusData[status.id]?.now || {
                deals_count: 0,
                budget: 0,
              }
              return (
                <div
                  key={status.id}
                  className={`${st.funnelCard} ${st.cardNow}`}
                >
                  <div
                    className={st.colorLine}
                    style={{
                      backgroundColor: status?.color?.body_color || '#ccc',
                    }}
                  ></div>
                  <div className={st.cardTitle}>{status.name}</div>
                  <div className={st.cardCount}>{info.deals_count} сделок</div>
                  <div className={st.cardBudget}>
                    {info.budget.toLocaleString()} ₸
                  </div>
                </div>
              )
            })}
          </div>

          {/* 2. СТРОКА ПЕРЕХОДОВ (ПЕРЕШЛИ В ЭТАП) */}
          <div className={st.rowContentRow}>
            <div className={st.sideLabel}>
              ПЕРЕШЛИ
              <br />В ЭТАП
            </div>
            {statuses.map((status) => {
              const info = statusData[status.id]?.moved_to_status || {
                deals_count: 0,
                budget: 0,
              }
              return (
                <div key={status.id} className={st.funnelCardArrowWrapper}>
                  <div className={st.cardArrowContent}>
                    <div className={st.cardCount}>
                      {info.deals_count}
                      <br />
                      сделок
                    </div>
                    <div className={st.cardBudget}>
                      {info.budget.toLocaleString()} ₸
                    </div>
                  </div>
                </div>
              )
            })}
          </div>

          {/* 3. СТРОКА ПОТЕРЬ (ПОТЕРЯННЫЕ) */}
          <div className={st.rowLostRow}>
            <div className={st.sideLabel}>ПОТЕРЯННЫЕ</div>
            {statuses.map((status) => {
              const info = statusData[status.id]?.lost || {
                deals_count: 0,
                budget: 0,
              }
              const isAllZero = info.deals_count === 0 && info.budget === 0
              return (
                <div
                  key={status.id}
                  className={`${st.funnelCardArrowWrapper} ${st.funnelCardArrowWrapperLost}`}
                >
                  <div className={`${isAllZero ? st.emptyLost : ''}`}>
                    <div className={st.cardCount}>
                      {info.deals_count} сделок{isAllZero ? ', 0 ₸' : ''}
                    </div>
                    {!isAllZero && (
                      <div className={st.cardBudget}>
                        {info.budget.toLocaleString()} ₸
                      </div>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FunnelAnalyticsBlock
